export type HomeworkStatus = 'active' | 'complete' | 'canceled';
export const HomeworkStatuses = {
  active: 'Active',
  complete: 'Complete',
  canceled: 'Canceled'
} as const;

export type HomeworkType = 'erp' | 'task' | 'assessment';
export const HomeworkTypes = {
  erp: 'ERP',
  task: 'Task'
} as const;

type HomeworkBase = {
  id?: string;
  homeworkType: HomeworkType | null;
  description: string | undefined;
  purpose?: string | null;
  canceled: boolean;
  dueDate: Date | undefined;
  progress?: number;
  readonly provider?: { name: string };
  obsessionId?: string | null;
  compulsionId?: string | null;
  triggerId?: string | null;
  readonly completedTs?: Date | null;
  createdBy?: string;
  readonly obsessionTypeId?: string;
  readonly obsessionTypeName?: string;
  readonly obsessionName?: string;
  readonly compulsionName?: string;
  readonly triggerName?: string;
};

export type HomeworkTrial = {
  id: string;
  order: number;
  goalSeconds: number;
  submittedSeconds?: number;
  startingAnxiety?: number;
  endingAnxiety?: number;
  notes?: string;
};

export type HomeworkTask = {
  startingAnxiety?: number;
  endingAnxiety?: number;
  notes?: string;
};

export type ERPHomework = HomeworkBase & {
  trials?: [HomeworkTrial];
};

export type TaskHomework = HomeworkBase & {
  task?: HomeworkTask | null;
};

export type Homework = ERPHomework | TaskHomework;

export function isERPHomework(homework: HomeworkBase): homework is ERPHomework {
  return homework.homeworkType === 'erp';
}

export function isTaskHomework(
  homework: HomeworkBase
): homework is TaskHomework {
  return homework.homeworkType === 'task';
}
